<!--sidebar-->
<nav class="sidebar vh-100 d-none d-md-flex flex-column align-items-center py-3">
    <!--logo-->
    <a routerLink="/home/overview" data-bs-dismiss="offcanvas">
        <img src="images/logo_1_2.png" class="mb-3" style="height: 2.25rem;" title="Logo">
    </a>
    <!--./logo-->

    <!--nav-links-->
    <ul class="nav flex-column w-100" role="list">
        <li class="nav-item">
            <a routerLink="/home/overview" routerLinkActive="active" class="nav-link d-flex justify-content-center p-3"
                data-bs-toggle="tooltip" data-bs-placement="right" title="Home" data-bs-dismiss="offcanvas">
                <i class="nav-icon bi-house-fill"></i>
            </a>
        </li>
        <li class="nav-item">
            <a [routerLink]="arena() ? ['/home/chat'] : null" routerLinkActive="active"
                class="nav-link d-flex justify-content-center p-3" data-bs-toggle="toolitip" data-bs-placement="right"
                title="Chat" [class.disabled]="!arena()" data-bs-dismiss="offcanvas">
                <i class="nav-icon bi-chat-left-dots-fill"></i>
            </a>
        </li>
        <li class="nav-item">
            <a routerLink="/home/library" routerLinkActive="active" class="nav-link d-flex justify-content-center p-3"
                data-bs-toggle="tooltip" data-bs-placement="right" title="Library" data-bs-dismiss="offcanvas">
                <i class="nav-icon bi-controller"></i>
            </a>
        </li>
        <!--<li class="nav-item">
            <a routerLink="/home/store" routerLinkActive="active" class="nav-link d-flex justify-content-center p-3"
                data-bs-toggle="tooltip" data-bs-placement="right" title="Store">
                <i class="nav-icon bi-shop"></i>
            </a>
        </li>-->
        <li class="nav-item">
            <a routerLink="/home/rankings" routerLinkActive="active" class="nav-link d-flex justify-content-center p-3"
                data-bs-toggle="tooltip" data-bs-placement="right" title="Rankings" data-bs-dismiss="offcanvas">
                <i class="nav-icon bi-trophy-fill"></i>
            </a>
        </li>
        <li class="nav-item">
            <a routerLink="/home/help" routerLinkActive="active" class="nav-link d-flex justify-content-center p-3"
                data-bs-toggle="tooltip" data-bs-placement="right" title="Help & FAQ" data-bs-dismiss="offcanvas">
                <i class="nav-icon bi-question-circle-fill"></i>
            </a>
        </li>
    </ul>
    <!--./nav-links-->

    <!--logout-->
    <div class="mt-auto">
        <button class="nav-link d-flex justify-content-center p-3 border-0 bg-transparent w-100" data-bs-toggle="modal"
            data-bs-target="#settingsModal" data-bs-dismiss="offcanvas" (click)="openSettings()" title="Settings">
            <i class="nav-icon bi-gear-fill"></i>
        </button>
        <a routerLink="/login" class="nav-link d-flex justify-content-center p-3" data-bs-toggle="tooltip"
            data-bs-placement="right" title="Logout" data-bs-dismiss="offcanvas">
            <i class="nav-icon bi-box-arrow-right"></i>
        </a>
    </div>
    <!--./logout-->
</nav>
<!--./sidebar-->

<!--mobile-offcanvas-->
<div class="offcanvas offcanvas-start d-md-none" tabindex="-1" id="mainSidebarOffcanvas"
    aria-labelledby="mainSidebarOffcanvasLabel" style="background-color: #111;">
    <div class="offcanvas-header border-bottom-0">
        <div class="d-flex align-items-center">
            <a routerLink="/home/overview">
                <img src="images/logo_1_2.png" class="mb-3" style="height: 2.25rem;" title="Logo">
                <h5 class="offcanvas-title ms-3 fw-bold" id="mainSidebarOffcanvasLabel">RIVAL FORGE</h5>
            </a>
        </div>
        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body p-0 d-flex flex-column">
        <ul class="nav flex-column w-100" role="list">
            <li class="nav-item">
                <a routerLink="/home/overview" routerLinkActive="active"
                    class="nav-link d-flex align-items-center p-3 fs-5" data-bs-dismiss="offcanvas">
                    <i class="nav-icon bi-house-fill me-3" style="font-size: 1.5rem;"></i> Home
                </a>
            </li>
            @if(arena() !== null) {
            <li class="nav-item">
                <a routerLink="/home/chat" routerLinkActive="active" class="nav-link d-flex align-items-center p-3 fs-5"
                    data-bs-dismiss="offcanvas">
                    <i class="nav-icon bi-chat-left-dots-fill me-3" style="font-size: 1.5rem;"></i> Chat
                </a>
            </li>
            }
            <!--<li class="nav-item">
                <a routerLink="/home/store" routerLinkActive="active"
                    class="nav-link d-flex align-items-center p-3 fs-5" data-bs-dismiss="offcanvas">
                    <i class="nav-icon bi-shop me-3" style="font-size: 1.5rem;"></i> Store
                </a>
            </li>-->
            <li class="nav-item">
                <a routerLink="/home/library" routerLinkActive="active"
                    class="nav-link d-flex align-items-center p-3 fs-5" data-bs-dismiss="offcanvas">
                    <i class="nav-icon bi-controller me-3" style="font-size: 1.5rem;"></i> Library
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/home/rankings" routerLinkActive="active"
                    class="nav-link d-flex align-items-center p-3 fs-5" data-bs-dismiss="offcanvas">
                    <i class="nav-icon bi-trophy-fill me-3" style="font-size: 1.5rem;"></i> Rankings
                </a>
            </li>
            <li class="nav-item">
                <a routerLink="/home/help" routerLinkActive="active" class="nav-link d-flex align-items-center p-3 fs-5"
                    data-bs-dismiss="offcanvas">
                    <i class="nav-icon bi-question-circle-fill me-3" style="font-size: 1.5rem;"></i> Help & FAQ
                </a>
            </li>
            <li class="nav-item">
                <button class="nav-link d-flex align-items-center p-3 fs-5 border-0 bg-transparent text-start w-100"
                    data-bs-toggle="modal" data-bs-target="#settingsModal" data-bs-dismiss="offcanvas"
                    (click)="openSettings()">
                    <i class="nav-icon bi-gear-fill me-3" style="font-size: 1.5rem;"></i> Settings
                </button>
            </li>

        </ul>
        <div class="mt-auto p-3">
            <a routerLink="/login" class="nav-link d-flex align-items-center p-3 fs-5" data-bs-dismiss="offcanvas">
                <i class="nav-icon bi-box-arrow-right me-3" style="font-size: 1.5rem;"></i> Logout
            </a>
        </div>
    </div>
</div>
<!--./mobile-offcanvas-->